<template>
  <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
    <div class="home-donations app-bg-gradient">
    <div class="stars-bg"></div>
    <div class="payment-failed">
      <Languages class="languages" v-bind:settings="true"></Languages>
      <Timer v-if='timerStart' :setTime="setTime"></Timer>
      <div class="mosque-name">{{user.data.name}}</div>
      <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
      <div class="donations-status-sec">
        <h3 class="in-sentence">{{"Transaction has been failed with status" | translate}} <span class="errormsg">"{{errorMessage | translate}}"</span></h3>
        <h3 class="in-sentence-rearange"><span>{{"Transaction has been" | translate}}</span>&nbsp;<span class="errormsg">"{{errorMessage | translate}}"</span>&nbsp;<span>{{"failed with status" | translate}}</span></h3>
        <div class="flex btns-sec">
          <div class="btn-bg1 retry">
            <div class="btn-bg2">
              <button @click="tryAgain" class="cursor login">{{"Retry" | translate}}</button>
            </div>
          </div>
          <div class="btn-bg1">
            <div class="btn-bg2">
              <button @click="cancel" class="cursor login">{{"Cancel" | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Timer from './timer.vue'
import Languages from './Languages'

export default {
  data () {
    return {
      setTime: 2,
      timerStart: true,
      failedReason: null,
      tid: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'terminalNotificationStatus',
      'token'
    ]),
    errorMessage () {
      return this.failedReason
    }
  },
  methods: {
    ...mapActions([
      'resetTerminalNotificationStatus',
      'resetEmailStatus',
      'changeLoadingStatus'
    ]),
    tryAgain () {
      this.$router.push({path: `/${this.tid}/confirm/${this.$route.params.donationType}/${this.$route.params.donateAmount}`})
    },
    cancel () {
      localStorage.removeItem('payment-status')
      localStorage.removeItem('payment-req-status')
      localStorage.removeItem('donation-type')
      localStorage.removeItem('donation-amount')
      localStorage.removeItem('email-status')
      this.resetEmailStatus()
      this.$router.push({path: `/${this.tid}/donations`})
    }
  },
  components: {
    Timer,
    Languages
  },
  mounted: function () {
    this.resetTerminalNotificationStatus()
    this.setTime = 0.25
    this.failedReason = this.$route.params.failedReason
    this.tid = this.$route.params.terminalId

    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-donations {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.mosque-name {
  font-size: 40px;
  color: #FFF;
  font-family: "Lato";
  font-weight: bold;
  text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
  margin-top: 61px;
  margin-bottom: 50px;
  letter-spacing: 2px;
  text-align: center;
}
.donations-status-sec {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 200px);
  flex-direction: column;
}
.donations-status-sec h3 {
  color: #880913;
  font-size: 26px;
  font-weight: 600;
}
.donations-status-sec h3 .errormsg {
  font-size: 32px;
}
.btn-bg1 {
  margin-top: 30px;
}
.retry {
  margin-right: 30px;
}
.payment-failed {
  z-index: 2
}
.full-screen {
  background-position: 50%;
}
div[dir='rtl'] .btns-sec .retry {
  margin-right: initial;
  margin-left: 30px;
}
@media only screen and (min-width: 2000px) {
  .donations-status-sec h3 {
    font-size: 100px;
    margin-bottom: 10%;
    letter-spacing: 6px;
  }
  .donations-status-sec h3 .errormsg {
    font-size: 110px;
  }
  .donations-status-sec {
    height: 70vh;
  }
  .btn-bg1 {
    margin-top: 200px;
    z-index: 2;
    width: 620px !important;
    height: 200px !important;
    border-radius: 200px;
  }
  .btn-bg2 {
    width: 607px;
    height: 187px;
    border-radius: 200px;
  }
  button {
    width: 594px;
    height: 178px;
    border-radius: 200px;
    font-size: 70px;
    letter-spacing: 3px;
  }
  .retry {
    /* margin-right: 5%; */
  }
  .btns-sec {
    width: 40vw;
  }
  div[dir='rtl'] .retry {
    margin-right: initial;
    margin-left: 5%;
  }
}

@media screen and (min-width: 1200px) and (min-height: 904px) {
  .btn-bg1 {
    width: 190px;
    height: 64px;
    min-height: 64px;
  }
  .btn-bg2 {
    width: 182px;
    height: 56px;
  }
  button.login {
    width: 180px;
    height: 54px;
    font-size: 20px;
  }
  .donations-status-sec {
    height: 70vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment-failed.vue